import React from 'react';

export const noBorder = (WrappedComponent) => {
  function NoBordered({ ...props }) {
    return <WrappedComponent {...props} noBorder noBackground />;
  }

  return NoBordered;
};

export default noBorder;
